import Vue from "vue"
import App from "@/App"
import router from "@/router"
import i18n from "@/i18n"
import "@/assets/styles/global.less"

import quasarConfig from "@/Quasar"
Vue.use(...quasarConfig)

console.log(`Fast DXF Viewer version: ${DXF_VIEWER_VERSION} - by bytethink.dev`);

// 设置HTML lang属性
document.documentElement.setAttribute('lang', i18n.locale)

new Vue({
    el: "#app",
    router,
    i18n,
    render: h => h(App)
})
